import { FunctionName } from "./FunctionRegistry";
export class FunctionParams {
    getParams(actionData, sourceNode, context = {}) {
        return {};
    }
}
export class TextGenerationParams extends FunctionParams {
    getParams(actionData, sourceNode, context = {}) {
        return {
            url: undefined,
            identifierType: actionData.identifierType,
            identifierValue: actionData.identifierValue,
            streaming: !context.isNested,
            domain: undefined,
        };
    }
}
export class AddDataSourceParams extends FunctionParams {
    getParams(actionData, sourceNode, context = {}) {
        const fileOnEdge = actionData.enterText === FunctionName.addDataSource ||
            actionData.enterText === `/${FunctionName.addDataSourceValue}`;
        // 上传的文件不在边上
        if (!fileOnEdge) {
            const content = JSON.parse(sourceNode.content);
            const loader = "PDFReader";
            const file = content.s3Path || content.value;
            let json = undefined;
            if (!file) {
                json = content;
            }
            const fileUuid = actionData.fileUuid || content.uuid;
            const query = actionData.enterText.replace("/", "");
            const params = {
                query: query,
                fileUuid: fileUuid,
                loader: loader,
                file: file,
                json: json,
            };
            return params;
        }
        else {
            // 上传的文件在边上，不在node 上
            return actionData.requestParam;
        }
    }
}
export class FunctionParamsManager {
    static getByType(functionName) {
        // bind params types with function name
        const map = {};
        map[FunctionName.textGeneration] = TextGenerationParams;
        map[FunctionName.addDataSource] = AddDataSourceParams;
        map[FunctionName.empty] = FunctionParams;
        this.map = map;
        let Instance = this.map[functionName || FunctionName.empty];
        if (!Instance) {
            Instance = this.map[FunctionName.empty];
        }
        return new Instance();
    }
}
